import { render } from "./DanhSachToaXeTable.vue?vue&type=template&id=09c4049d&ts=true"
import script from "./DanhSachToaXeTable.vue?vue&type=script&lang=ts"
export * from "./DanhSachToaXeTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__